import { EmptyState } from '@app/components/base/EmptyState';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export function TranscriptionEmpty() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <EmptyState
        icon={SpeakerNotesOffIcon}
        message={
          <FormattedMessage
            id="audit.transcriptionScreen.noResults"
            defaultMessage="No transcriptions found"
          />
        }
        help={<div />}
      ></EmptyState>
    </Box>
  );
}
